// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".df28f48e6f5c5a60403e0224db5c034398fb2288.chunk.bundle.js";
};